export default "__VITE_ASSET__Biz1sjZ0__"